import React from 'react';

const LoadingAnimation = ({ label }) => {
  return (
    <>
      <div className="fuselight-v5-loading-animation">
        <div className="fuselight-loading-lights">
          <div className="light light-one"></div>
          <div className="light light-two"></div>
          <div className="light light-three"></div>
          <div className="light light-four"></div>
        </div>
        {label && <h3>{label}</h3>}
      </div>
    </>
  );
};

export default LoadingAnimation;
